import Vue from 'vue';

Vue.component('stock-receive-index', () =>
    import(/* webpackChunkName: 'stock-receive-index' */ './stock-receive-index.vue'),
);
